import React from 'react';
import PropTypes from 'prop-types';

const CodebookElements = ({ searchInput, onInputChange }) => (
  <div>
    <div className="cb_container main">
      <div id="nav_arrows" className="hide">
        <div id="to_menu" className="hide"></div>
        <div id="to_content" className="hide"></div>
      </div>
      <section className="cb_nav">
        <nav>
          <section id="cb_topics">
            <div className="filter_header">
              <h5>Discover by Topic</h5>
              <button className="menu_reset" id="reset_theme_select">Reset</button>
            </div>
            <div id="topic_list">
              <div id="theme_menu" className="sidenav"> </div>
            </div>
          </section>
          <section id="cb_filters">
            <div className="filter_header">
              <h5>Filters</h5>
              <button className="menu_reset" id="reset_filters">Reset</button>
            </div>
            <div id="data_filters">
              <div id="filter_menu" className="sidenav"> </div>
            </div>
          </section>
          <section id="cb_search">
            <div className="filter_header">
              <h5>Search Questions</h5>
              <button className="menu_reset" id="reset_search">Reset</button>
            </div>
            <input
              type="text"
              id="cb_search_text"
              value={searchInput}
              onChange={(e) => { onInputChange(e.target.value); }}
              placeholder="  Search question wording"
            />
            <button id="cb_search_btn" className="search"></button>
          </section>
        </nav>
      </section>
      <section id="cb_content" className="cb_content">
        <section id="cb_content_header">
          <h1>
            <a href="">&nbsp;</a>
          </h1>
          <div id="question_filter" className="hide">
            <span> Applied Filter: test</span>
            <button id="question_filter_btn"></button>
          </div>
        </section>
        <section id="question_list">
          <ul id="question_list_ul"></ul>
        </section>
      </section>
      <section id="cb_blank_content">
        <div>
          <div className="explore"></div>
          <h6>Explore data by theme, <br />or search data to get started</h6>
        </div>
      </section>
    </div>
  </div>
);

CodebookElements.propTypes = {
  searchInput: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default CodebookElements;



// WEBPACK FOOTER //
// ./app/containers/Codebook/CodebookElements.js